import React, { useEffect } from "react";
import ConsentFormsNavbar from "../../components/common/ConsentFormsNavbar";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router";
import LdcApi from "../../LdcApis";
import { useState } from "react";

const VideoConsultation = () => {
  const { id, roomId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [embedId, setEmbedId] = useState("");
  const [errMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    document.title = "Video Consultation - LDC";
  }, []);

  useEffect(() => {
    if (location.state == null) {
      navigate(`/video-OTP/${id}/roomId/${roomId}`);
    }
  }, [id]);
  useEffect(() => {
    setLoading(true);
    LdcApi({
      method: "GET",
      url: `video/ValidateRoom?roomId=${roomId}`,
    })
      .then((res) => {
        if (res.data.status.isSuccess == true) {
          setEmbedId(res.data.data.embed);
          setLoading(false);
        } else {
          setErrorMsg(res.data.status.errorMessage);
          setEmbedId(null);
          setLoading(false);
        }
      })
      .catch((err) => {
        setErrorMsg("Something is Wrong");
        setEmbedId(null);
        setLoading(false);
      });
  }, []);
  return (
    <div>
      <ConsentFormsNavbar />
      <Container className="pt-5">
        <div
          className="mt-5 d-flex justify-content-center"
          style={{ width: "1150px" }}
        >
          {loading === true ? (
            <>Loading...</>
          ) : (
            <>
              {embedId == null ? (
                <>
                  <p style={{ fontSize: "1.4rem" }} className="text-center">
                    {errMsg}
                  </p>
                </>
              ) : (
                <iframe
                  className="shadow"
                  // style={{ border: '1px solid #000' }}
                  src={`https://tokbox.com/embed/embed/ot-embed.js?embedId=${embedId}&room=${roomId}&iframe=true`}
                  width="90%"
                  height="700"
                  scrolling="auto"
                  allow="microphone; camera"
                ></iframe>
              )}
            </>
          )}
        </div>
      </Container>
    </div>
  );
};

export default VideoConsultation;
